import type { CollectGraphqlFilters } from '~/types/graphql-backend-types/gql-types'
import { useQuery } from '@tanstack/vue-query'
import gql from 'graphql-tag'
import { useGqlMikro } from '~/composables/useGqlMikro'

export const INCOMING_COLLECTS_QUERY_KEY = (filters: MaybeRefOrGetter<CollectGraphqlFilters>, page: MaybeRefOrGetter<number>) => ['incoming-collects', { filters, page }]

export function useIncomingCollects(filters: MaybeRefOrGetter<CollectGraphqlFilters>, page: MaybeRefOrGetter<number>) {
  const { query } = useGqlMikro()
  const { selectedOrgId } = storeToRefs(useOrganizationStore())

  return useQuery({
    queryKey: INCOMING_COLLECTS_QUERY_KEY(filters, page),
    queryFn: async () => {
      const f = toValue(filters)

      const { data, errors } = await query({
        query: INCOMING_COLLECTS_QUERY,
        variables: {
          pagination: { limit: 10, offset: (toValue(page) - 1) * 10 },
          filters: {
            ...(f.companyIds && f.companyIds.length > 0 && { companyIds: f.companyIds }),
            orderBy: { field: 'startsAt', order: f.orderBy?.order },
            ...(f.status && f.status.length > 0 && { status: f.status }),
            ...(selectedOrgId.value && { organizationIds: [selectedOrgId.value] }),
            ...(f.startsAtFrom && { startsAtFrom: f.startsAtFrom }),
            ...(f.startsAtTo && { startsAtTo: f.startsAtTo }),
            search: f.search ?? null,
          },
        },
      })

      if (errors && errors.length > 0) {
        throw errors
      }

      return data.collects
    },
  })
}

export const INCOMING_COLLECTS_QUERY = gql`
query IncomingCollects($pagination: PaginationArgs!, $filters: CollectGraphqlFilters) {
  collects(pagination: $pagination, filters: $filters) {
    count
    collection {
      status
      id
      startsAt
    }
  }
}
`
